import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Voucher } from "@modules/vouchers/types";
import { VoucherFormValues } from "@modules/vouchers/validations";

import { createVoucherService } from "./service";
import { UseCreateVoucherMutationOptions } from "./types";

export function useCreateVoucherMutation(
  options?: UseCreateVoucherMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Voucher, ApiError, VoucherFormValues>({
    mutationFn: createVoucherService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
